import { authHeader, handleResponse } from '../helpers';
export const DamageComplaintReportService = {
    fetchFeedbackData   
};

function fetchFeedbackData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/UserDemageQrCodecomplaintRpt`, requestOptions)
        .then(handleResponse);
}